import { SelectField, TextField } from '@shared/design-system/ui'
import { accountSection, accountSectionTitle, full, grid, sectionCopy } from './onboarding.css'

export type BusinessProfileFieldsValue = {
  url: string
  productDescription: string
  mcc: string
}

export type BusinessProfileFieldErrors = Partial<Record<keyof BusinessProfileFieldsValue, string>>

// The identity schema accepts any four-digit MCC; keep this seller-facing list small and map it to Stripe-compatible values.
const businessCategoryOptions = [
  { label: 'Cursos e infoprodutos', value: '8299' },
  { label: 'Educação', value: '8211' },
  { label: 'Software e aplicativos', value: '5734' },
  { label: 'Serviços digitais e consultoria', value: '7392' },
  { label: 'Conteúdo e assinaturas digitais', value: '5815' },
  { label: 'Comércio de produtos físicos', value: '5999' },
  { label: 'Outros', value: '8999' },
]

export function ProfileBusinessFields({
  value,
  errors,
  hints,
  disabled = false,
  onChange,
  onBlur,
}: {
  value: BusinessProfileFieldsValue
  errors: BusinessProfileFieldErrors
  hints?: BusinessProfileFieldErrors
  disabled?: boolean
  onChange: (value: BusinessProfileFieldsValue) => void
  onBlur?: (field: keyof BusinessProfileFieldsValue) => void
}) {
  return (
    <section className={accountSection}>
      <h3 className={accountSectionTitle}>Seu negócio</h3>
      <p className={sectionCopy}>Esses dados ajudam a identificar a atividade do negócio.</p>
      <div className={grid}>
        <TextField
          className={full}
          label="Site do negócio"
          placeholder="https://exemplo.com.br"
          value={value.url}
          disabled={disabled}
          error={errors.url}
          data-profile-check-hint={Boolean(hints?.url) || undefined}
          helperText={hints?.url}
          onBlur={() => onBlur?.('url')}
          onChange={(event) => onChange({ ...value, url: event.target.value })}
        />
        <TextField
          className={full}
          label="Descrição do negócio"
          maxLength={400}
          value={value.productDescription}
          disabled={disabled}
          error={errors.productDescription}
          data-profile-check-hint={Boolean(hints?.productDescription) || undefined}
          helperText={hints?.productDescription}
          onBlur={() => onBlur?.('productDescription')}
          onChange={(event) => onChange({ ...value, productDescription: event.target.value })}
        />
        <SelectField
          label="Categoria do negócio"
          value={value.mcc}
          disabled={disabled}
          error={errors.mcc}
          data-profile-check-hint={Boolean(hints?.mcc) || undefined}
          helperText={hints?.mcc ?? 'Escolha a categoria que melhor descreve sua atividade.'}
          onBlur={() => onBlur?.('mcc')}
          placeholder="Selecione uma categoria"
          options={categoryOptionsFor(value.mcc)}
          onChange={(event) => onChange({ ...value, mcc: event.target.value })}
        />
      </div>
    </section>
  )
}

function categoryOptionsFor(value: string) {
  if (value && !businessCategoryOptions.some((option) => option.value === value)) {
    return [{ label: `Outra categoria (código ${value})`, value }, ...businessCategoryOptions]
  }
  return businessCategoryOptions
}
